import {
  createRootStoreModel,
  type RootStoreModelEnvironment,
  type RootStoreModelInstance,
  type RootStoreModelSnapshotIn,
  type WithRootStore,
} from './RootStoreModel'

let rootStore: RootStoreModelInstance | null = null

function createRootStore(rootStoreEnvironment: RootStoreModelEnvironment): RootStoreModelInstance {
  const rootStoreSnapshot: RootStoreModelSnapshotIn = {
    notificationStore: {},
    centerSettingsStore: {},
    navbarStore: {},
    loginStore: {},
    checklistReportsStore: {},
    usersStore: {},
    missionHistoryStore: {},
    checklistsStore: {},
    commonSettingsStore: {},
    partNumbersStore: {},
    discrepancyReportsStore: {},
    vehiclesStore: {},
    mapEntitiesStore: {},
  }
  
  rootStore = createRootStoreModel(rootStoreSnapshot, rootStoreEnvironment)

  Object.assign(window, { rootStore })
  return rootStore
}

const getOrCreateRootStore = (rootStoreEnvironment: RootStoreModelEnvironment): RootStoreModelInstance =>
  rootStore || createRootStore(rootStoreEnvironment)

export const getOrCreateStore = (rootStoreEnvironment: RootStoreModelEnvironment): WithRootStore => ({
  store: getOrCreateRootStore(rootStoreEnvironment),
})

export function getRootStore(): RootStoreModelInstance {
  if (rootStore === null) {
    throw Error('Root store not yet initialized')
  }
  return rootStore
}

export interface RootStoreEnvironment extends RootStoreModelEnvironment {}
